/**
 * The one line that explains why this thread stopped being a chat.
 *
 * When the intent engine upgrades an opening message to a Work run, the whole
 * screen changes underneath someone who only pressed send. Without a note
 * saying so, the product looks like it did something arbitrary. This sits
 * directly under their message, where the answer would have started.
 */
import React from 'react';
import { View, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';
import { useTheme } from '@/context/ThemeContext';
import { useTranslation } from '@/hooks/useTranslation';
import WorkAppear from '@/components/Coworker/WorkAppear';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';

// The backend decides *that* a thread was upgraded; the wording stays here so
// it can be translated with the rest of the chat UI.
function WorkUpgradeNotice({ style }) {
  const { colors } = useTheme();
  const { t } = useTranslation();

  return (
    <WorkAppear style={style} duration={260} distance={6}>
      <View style={[styles.row, { borderColor: colors.border_color_secondary }]}>
        <Icon name="wand-magic-sparkles" size={12} color={colors.text_color_tertiary} />
        <Text size="xxs" color="tertiary" style={styles.copy}>
          {t('chat.workUpgrade.notice')}
        </Text>
      </View>
    </WorkAppear>
  );
}

WorkUpgradeNotice.propTypes = {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default React.memo(WorkUpgradeNotice);

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderRadius: 10,
    marginBottom: 4,
  },
  copy: {
    flex: 1,
    lineHeight: 16,
  },
});
